import styled from "styled-components";
import {
  Button,
  FormControl,
  Input,
  InputLabel,
  Typography,
} from "@material-ui/core";

export const StyledInput = styled(Input)`
  width: ${(props) => props.width};
  margin: 0 auto;
  &.MuiInputBase-root {
    background-color: ${(props) => props.theme.palette.primary.dark};
    border-radius: ${(props) => props.theme.border.radius};
    box-shadow: ${(props) =>
      props.theme.border.shadow + props.theme.palette.primary.dark};

    color: ${(props) => props.theme.palette.secondary.light}!important;
    font-size: 14px;
    font-weight: 600;
    padding: 0.5vh 2vh;
  }
  & .MuiTypography-colorTextSecondary {
    // position: absolute;
    color: ${(props) => props.theme.palette.secondary.light}!important;
  }
  & textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus,
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-internal-autofill-selected {
    background-color: none;
    border: none;
    -webkit-text-fill-color: ${(props) => props.theme.palette.secondary.light};
    caret-color: ${(props) => props.theme.palette.secondary.light};
    transition: background-color 5000s ease-in-out 0s;
    font-size: 14px;
    font-weight: 600;
  }

  // styling to remove the underline
  ::after,
  ::before {
    border-bottom: 0 !important;
  }
`;
export const Highlight = styled.span`
  display: inline-flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: 5px;

  background-color: ${(props) => props.theme.palette.secondary.main};
  box-shadow: ${(props) =>
    props.theme.border.shadow + props.theme.palette.primary.dark};
  padding: 1px 6px;
  border-radius: ${(props) => props.theme.border.radius};

  margin: 5px 0;
`;
export const StyledLabel = styled(InputLabel)`
  //   min-width: 300px;

  font-weight: 600 !important;
  font-size: 18px !important;
  pointer-events: none;

  &.MuiFormLabel-root {
    color: ${(props) => props.theme.palette.secondary.main};
    z-index: 1; // make label appear above input field
    right: 0; //makes the label appear in the centre
  }
  ,
  &.MuiFormLabel-root.Mui-focused {
    //change the color when focused
    color: ${(props) => props.theme.palette.secondary.light};
  }
`;
export const StyledButton = styled(Button)`
  &.MuiButton-root {
    color: ${(props) => props.theme.palette.primary.dark};
    background-color: ${(props) =>
      props.color === "secondary"
        ? props.theme.palette.secondary.light
        : props.theme.palette.yellow.light};

    background-color: ${(props) =>
      props.disabled && props.theme.palette.red.light};
    background-color: ${(props) =>
      props.selected && props.theme.palette.secondary.light}!important;

    box-shadow: ${(props) =>
      props.theme.border.shadow + props.theme.palette.primary.dark};
    font-weight: 700;
    margin-top: 2vh;
  }
  &.MuiButton-root:hover {
    background-color: ${(props) => props.theme.palette.yellow.main};
  }
`;
export const StyledPage = styled.div`
  text-align: left;

  min-height: 100vh;
  width: 80%;
  margin: 5vh auto;
  padding: 5vh 5%;

  color: white;
  background-color: ${(props) => props.theme.palette.primary.main};
  border-radius: ${(props) => props.theme.border.radius};
  box-shadow: ${(props) =>
    props.theme.border.shadow + props.theme.palette.primary.dark};
`;
export const StyledFormControl = styled(FormControl)`
  margin: 0 5px !important;
  // &.Mui-FormControl-root {
  //   margin: 0 2vw;
  // }
`;
export const A = styled.a`
  color: ${(props) => props.theme.palette.secondary.light};
`;
